<template>
  <q-card flat class="card" @click="onClick" @dblclick="dblclick" v-ripple>
    <slot v-if="customImage" name="image"></slot>
    <q-img v-else :src="imageUrl" style="height: 144px">
      <div class="full-width bg-transparent" style="padding: 10px !important">
        <q-img
          v-if="iconImageUrl"
          :class="`${iconLeft ? 'float-left' : 'float-right'}`"
          :src="iconImageUrl"
          style="height: 27px; width: 27px; background-color: transparent"
        >
        </q-img>
        <slot
          v-else
          :class="`${iconLeft ? 'float-left' : 'float-right'}`"
          name="icon"
        ></slot>
      </div>
    </q-img>
    <q-card-section class="q-py-none">
      <slot v-if="customContent" name="content"></slot>
      <div v-else>
        <q-scroll-area style="height: 130px">
          <div class="row justify-between items-center">
            <div class="headerSmall q-py-xs">
              {{ headerSmallLeft }}
            </div>
            <div class="headerSmall">
              {{ headerSmallRight }}
            </div>
          </div>

          <div class="mainHeader q-mt-xs" style="height: 32px">
            {{ mainHeader }}
          </div>

          <div class="row q-mt-sm" v-if="description">
            <div class="description">
              {{ description }}
            </div>
          </div>
          <div class="row q-mt-sm" v-if="descriptionHTML">
            <div class="description" v-html="descriptionHTML"></div>
          </div>
          <div class="row q-mt-sm" v-if="!descriptionHTML && !description">
            <div class="description"></div>
          </div>
        </q-scroll-area>

      </div>

    </q-card-section>
    <div class="row items-center justify-end">
      <q-icon class="float-right bottomIcon q-mr-xs" :name="bottomIcon">
      </q-icon>
      <span class="iconText q-mr-md">{{ bottomIconText }}</span>
    </div>


  </q-card>
</template>

<script>
  export default {
    props: {
      imageUrl: {
        type: String,
        default: null,
      },
      iconLeft: {
        type: Boolean,
        default: false,
      },
      iconImageUrl: {
        type: String,
        default: null,
      },
      customContent: {
        type: Boolean,
        default: false,
      },
      customImage: {
        type: Boolean,
        default: false,
      },
      headerSmallLeft: {
        type: String,
        default: null,
      },
      headerSmallRight: {
        type: String,
        default: null,
      },
      mainHeader: {
        type: String,
        default: null,
      },
      description: {
        type: String,
        default: null,
      },
      descriptionHTML: {
        type: String,
        default: null,
      },
      bottomIcon: {
        type: String,
        default: null,
      },
      bottomIconText: {
        type: String,
        default: null,
      },
    },
    methods: {
      onClick() {
        this.$emit("onClick");
      },
      dblclick() {
        this.$emit("dblclick");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    height: 293px;
    width: 217px;
    background-color: #f6f6f6 !important;
  }

  .headerSmall {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 7.97588px;
    color: rgba(22, 44, 71, 0.5);
  }

  .description {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 9.96985px;
    color: rgba(22, 44, 71, 0.5);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .mainHeader {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 10.9668px;
    color: #162c47;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .iconText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 7.97588px;
    color: #6cbd4f;
  }

  .bottomIcon {
    color: #6cbd4f;
  }
</style>
